import React from 'react';
import _ from 'lodash';
import { translate } from '@fiverr-private/i18n-react';
import RelatedGuides from '@fiverr-private/related_guides';
import { Tips, type TipsData } from '@fiverr-private/seo_content';
import { BRAND_STYLE_GUIDE_SC_SLUG } from '../../../utils/constants';
import { Faqs } from './components/Faqs';
import { RelatedLinks } from './components/RelatedLinks';
import './index.scss';

interface SeoSubCategoryProps {
    title: string;
    faqs?: { question: string; answer: string }[];
    answersLink?: string;
    relatedLinksTitle?: string;
    relatedLinks?: { url: string; text: string; openInNewTab: boolean }[];
    relatedSkillsTitle?: string;
    relatedSkillsLinks?: { url: string; text: string; openInNewTab: boolean }[];
    relatedGuides?: { title: string; url: string }[];
    seeMoreText?: string;
    seeMoreLink?: string;
    cachedSlug: string;
    tips?: TipsData;
}

const SeoSubCategory = ({
    title,
    faqs = [],
    answersLink,
    relatedLinksTitle = '',
    relatedLinks = [],
    relatedSkillsTitle = '',
    relatedSkillsLinks = [],
    relatedGuides = [],
    seeMoreText = '',
    seeMoreLink = '',
    cachedSlug,
    tips,
}: SeoSubCategoryProps) => {
    const relatedGuidesSourcePageKey = `subcategories_${cachedSlug}`;
    const relatedGuidesTitle =
        cachedSlug === BRAND_STYLE_GUIDE_SC_SLUG
            ? translate('search_perseus.seo_sub_category.related_guides.brand_style_guides_title')
            : translate('search_perseus.seo_sub_category.related_guides.title', {
                  params: { sub_category_title: title },
              });

    return (
        <>
            {!_.isEmpty(tips) && <Tips data={tips} subCategory={title} />}
            {!_.isEmpty(relatedLinks) && <RelatedLinks title={relatedLinksTitle} relatedLinks={relatedLinks} />}
            {!_.isEmpty(relatedSkillsLinks) && (
                <RelatedLinks title={relatedSkillsTitle} relatedLinks={relatedSkillsLinks} />
            )}
            {!_.isEmpty(faqs) && <Faqs title={title} faqs={faqs} answersLink={answersLink} />}
            {!_.isEmpty(relatedGuides) && (
                <RelatedGuides
                    guides={relatedGuides}
                    seeMoreText={seeMoreText}
                    seeMoreLink={seeMoreLink}
                    title={relatedGuidesTitle}
                    sourcePageKey={relatedGuidesSourcePageKey}
                />
            )}
        </>
    );
};

export default SeoSubCategory;
